import { autoWebViewJs } from "@droid/android";
import { Box, Button, Modal } from "@mui/material";
import { useEffect, useState } from "react";

export function AndroidSettingsInfo() {
    const [permissions, setPermissions] = useState<string[]>([])
    const [open, setOpen] = useState(false)
    const onSettingClick = () => {
        const script = `
        com.fanfanlo.lib.utils.PermissionUtils.openAppSettings();`
        autoWebViewJs.callScript(script);
    }
    const handleClose = () => {
      setOpen(false);
    };
    useEffect(()=>{
        const script = 
        `
        var data = com.fanfanlo.lib.utils.PermissionUtils.getGrantedPermissions();
        var res = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(data);
        res;
        `
        const res = autoWebViewJs.callScript<string[]>(script)
        if(res.javaResultData){
            setPermissions(res.javaResultData)
        }
    }, [])
    return (
        <>
            <Box>
                <Box>
                    <span>授权</span>
                    <Button onClick={onSettingClick} data-testid="AndroidSettingsInfo__openSettingButton__01JG2B0060">打开设置页</Button>
                    <Button onClick={() => setOpen(true)} data-testid="AndroidSettingsInfo__grantedButton__01JG2B0061">已授权</Button>
                </Box>
            </Box>
            <Modal open={open}
        onClose={handleClose} data-testid="AndroidSettingsInfo__permissionsModal__01JG2B0062">
                <Box sx={{bgcolor:"background.paper", p:2}}>
                    <Box><span>已授权的权限</span><Button onClick={handleClose} data-testid="AndroidSettingsInfo__closeButton__01JG2B0063">关闭</Button></Box>
                    <ul>
                        {permissions.map((p, i) => <li style={{wordBreak:"break-all",wordWrap:"break-word"}} key={i}>{p.replace('android.permission', '')}</li>)}
                    </ul>
                </Box>
            </Modal>
        </>
    )
}